module.exports = __webpack_public_path__ + "img/metrics-icon-active.3fc43010.svg";